import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ReactPlayer from "react-player";
import { AiOutlineClose } from "react-icons/ai";

/**
 * Video popup.
 * - `url` / `type_url` are pulled out so they don't leak onto the Modal DOM element.
 * - Loader hides when the player is actually ready (fallback: 4s), not on a fixed 2s timer.
 * - Player is responsive (16:9) instead of a fixed 40rem height, so it fits on mobile.
 */
function VideoPlayerModal({ url, type_url, show, onHide, ...rest }) {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!show) return undefined;
    setIsLoading(true);
    const fallback = setTimeout(() => setIsLoading(false), 4000);
    return () => clearTimeout(fallback);
  }, [show, url]);

  const isIframe = type_url === "url_other";

  return (
    <Modal
      {...rest}
      show={show}
      onHide={onHide}
      size="xl"
      centered
      aria-label="Video player"
      dialogClassName="pt-video-modal"
    >
      <Modal.Body id="vps-modal-body" className="pt-video-modal-body">
        <Button
         
          className="pt-video-close"
          onClick={onHide}
          aria-label="Close video"
        >
          <AiOutlineClose size={20} />
        </Button>

        <div className="pt-video-frame">
          {isLoading && (
            <div className="loader-container pt-video-loader">
              <span className="loader"></span>
            </div>
          )}

          {show && url ? (
            isIframe ? (
              <iframe
                title="Video"
                src={url}
                className="other_url"
                allow="autoplay; encrypted-media; picture-in-picture"
                allowFullScreen
                onLoad={() => setIsLoading(false)}
              />
            ) : (
              <ReactPlayer
                width="100%"
                height="100%"
                url={url}
                controls
                playing
                onReady={() => setIsLoading(false)}
                onError={() => setIsLoading(false)}
              />
            )
          ) : null}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default VideoPlayerModal;
